import * as z from "zod";

export const sendRepairInvoice = {
  name: "sendRepairInvoice" as const,
  input: z.object({ returnId: z.string() }),
  output: z.object({}),
};
